module.exports = __webpack_public_path__ + "img/reporte_2.d930377a.svg";